import { RequestFieldDto } from "../Schemas/RequestFieldDto";
import { RequestParameterTypeEnum } from "../Enums/RequestParameterTypeEnum";

export const canSaveField = (field: RequestFieldDto) => {
    if (field.save === false) {
        field.save = true;
        return false;
    }
    return true;
}

export const guid = () => {
    function s4() {
        return Math.floor((1 + Math.random()) * 0x10000)
            .toString(16)
            .substring(1);
    }
    return (
        s4() +
        s4() +
        '-' +
        s4() +
        '-' +
        s4() +
        '-' +
        s4() +
        '-' +
        s4() +
        s4() +
        s4()
    );
}

export const getFileExtension = (fileName: string) => {
    return fileName.substring(fileName.lastIndexOf('.') + 1);
}

export const setDomElementValueById = (elementId: string, value: any) => {
    let element = document.getElementById(elementId);
    if (element != null) {
        (element as HTMLInputElement).value = value;
    }
}

export const levenshtein = (a: string, b: string): number => {
    const matrix = Array.from({ length: a.length + 1 }, () =>
        new Array(b.length + 1).fill(0)
    );

    for (let i = 0; i <= a.length; i++) matrix[i][0] = i;
    for (let j = 0; j <= b.length; j++) matrix[0][j] = j;

    for (let i = 1; i <= a.length; i++) {
        for (let j = 1; j <= b.length; j++) {
            const cost = a[i - 1] === b[j - 1] ? 0 : 1;

            matrix[i][j] = Math.min(
                matrix[i - 1][j] + 1,
                matrix[i][j - 1] + 1,
                matrix[i - 1][j - 1] + cost
            );
        }
    }

    return matrix[a.length][b.length];
};

export const isValidEmailShape = (value: string) => {
    if (!value) return false;

    const parts = value.split("@");
    if (parts.length !== 2) return false;

    const [local, domain] = parts;

    return local.length >= 1 && domain.length >= 1;
};

export const normalizeEmail = (value: string | null | undefined): string =>
    (value ?? "")
        .toLowerCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .replace(/ł/g, "l")
        .replace(/[\s\p{Cf}]+/gu, "");

export const normalizePhone = (value: string | null | undefined): string => {
    let phone = (value ?? "").trim();

    if (!phone) {
        return "";
    }

    // Remove spaces
    phone = phone.replace(/\s+/g, "");

    // ++421... -> +421...
    phone = phone.replace(/^\++/, "+");

    // 00421... -> +421...
    if (phone.startsWith("00")) {
        phone = "+" + phone.substring(2);
    }

    // Already international
    if (phone.startsWith("+")) {
        return phone;
    }

    // Slovak national format: 0XXXXXXXXX
    if (/^0\d{9}$/.test(phone)) {
        return "+421" + phone.substring(1);
    }

    // Already looks like international without +
    // (country code never starts with 0)
    if (/^[1-9]\d+$/.test(phone)) {
        return "+" + phone;
    }

    return phone;
};

export const isTypeOfFieldIdentificator = (fieldType: RequestParameterTypeEnum): boolean =>
    fieldType === RequestParameterTypeEnum.POISTKA_ID ||
    fieldType === RequestParameterTypeEnum.PARTNER_ID ||
    fieldType === RequestParameterTypeEnum.SKODA_ID;

export const isTypeOfFieldEmail = (fieldType: RequestParameterTypeEnum): boolean =>
    fieldType === RequestParameterTypeEnum.EMAIL ||
    fieldType === RequestParameterTypeEnum.CONTACT_EMAIL ||
    fieldType === RequestParameterTypeEnum.CLIENT_EMAIL;

export const isTypeOfFieldPhone = (fieldType: RequestParameterTypeEnum): boolean =>
    fieldType === RequestParameterTypeEnum.PHONE

/** Treats true / "true" / 1 / "1" as checked. */
export const isCheckboxTrue = (value: unknown): boolean => {
    if (value === true || value === 1) return true;
    if (typeof value === "string") {
        const normalized = value.trim().toLowerCase();
        return normalized === "true" || normalized === "1";
    }
    return false;
};
